import { Typography, styled } from '@mui/material';

const StyledAvailabilityStatusTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(18),
  fontWeight: 500,
  marginBottom: theme.spacing(1)
}));

export default StyledAvailabilityStatusTitle;
